<script lang="ts">
  import { step } from "../../stores/WalkinBookingStore";

  let selectedStep: number = 1;

  step.subscribe((value) => {
    selectedStep = value;
  });
</script>

<div class="w-full">
  <ul class="flex flex-row items-center justify-center w-full">
    <li
      class={`px-5 py-3.5 sm:px-5 sm:py-3 rounded-full relative mx-6 z-10 w-10 h-10 sm:w-12 sm:h-12 ${1 <= selectedStep ? "bg-brand text-white" : "bg-gray-200 text-gray-800"}`}
    >
      <span
        class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >1</span
      >
      <span
        class={`w-full z-0 h-0.5 absolute left-12 top-6 ${selectedStep > 1 ? "bg-brand" : "bg-gray-300"}`}
      ></span>
    </li>
    <li
      class={`px-5 py-3.5 sm:px-5 sm:py-3 rounded-full relative mx-6 z-10 w-10 h-10 sm:w-12 sm:h-12 ${2 <= selectedStep ? "bg-brand text-white" : "bg-gray-200 text-gray-800"}`}
    >
      <span
        class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >2</span
      >
      <span
        class={`w-full z-0 h-0.5 absolute left-12 top-6 ${selectedStep > 2 ? "bg-brand" : "bg-gray-300"}`}
      ></span>
    </li>
    <li
      class={`px-5 py-3.5 sm:px-5 sm:py-3 rounded-full relative mx-6 z-10 w-10 h-10 sm:w-12 sm:h-12 ${3 <= selectedStep ? "bg-brand text-white" : "bg-gray-200 text-gray-800"}`}
    >
      <span
        class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >3</span
      >
      <span
        class={`w-full z-0 h-0.5 absolute left-12 top-6 ${selectedStep > 3 ? "bg-brand" : "bg-gray-300"}`}
      ></span>
    </li>
    <li
      class={`px-5 py-3.5 sm:px-5 sm:py-3 rounded-full relative mx-6 z-10 w-10 h-10 sm:w-12 sm:h-12 ${4 <= selectedStep ? "bg-brand text-white" : "bg-gray-200 text-gray-800"}`}
    >
      <span
        class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >4</span
      >
    </li>
  </ul>
</div>
